import * as React from "react";
import type { SVGProps } from "react";
const SvgKulturIconMeny = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 65 51" {...props}>
    <path
      d="M1078.3 1010.95a31.5 31.5 0 0 0 13.11-.85 31.9 31.9 0 0 0 11.78-5.86c2.28-1.91 3.28-3.24 4.27-1.24a46 46 0 0 1 2.69 7.4c-2.35-1.04-5.49-.86-6.88 1.37a24.3 24.3 0 0 0-2.04 5.09l-4.99 1.35a6.28 6.28 0 0 0 3.88 2.54c0 .02-.01.03-.01.05a44.5 44.5 0 0 0-1.14 6.36 15.7 15.7 0 0 0-2.89.49c-7.51 2.03-8.62 7.7-8.62 7.7l11.23-3.03a36.3 36.3 0 0 0 1.38 10.38c-14.45 3.88-22.1-12.91-24.42-21.63a48.4 48.4 0 0 1-1.66-9.04c-.14-2.23 1.38-1.58 4.31-1.08m8.98 13.7c3.73-1 3.98-5.1 3.98-5.1l-9.96 2.69s2.24 3.42 5.98 2.41m25.64 27.79c-14.45-3.9-12.74-22.31-10.42-31.02a49.3 49.3 0 0 1 3.04-8.67c.99-2 1.99-.68 4.27 1.23a33.3 33.3 0 0 0 24.89 6.72c2.93-.5 4.46-1.15 4.31 1.08a48.6 48.6 0 0 1-1.66 9.04c-2.32 8.72-9.98 25.52-24.43 21.62m2.33-8.77c7.43 2 11.3-2.33 11.3-2.33l-19.92-5.38s1.12 5.68 8.62 7.71m-3.13-18.31c-3.73-1.01-5.98 2.41-5.98 2.41l9.96 2.69s-.24-4.1-3.98-5.1m14.94 4.03c-3.73-1.01-5.98 2.41-5.98 2.41l9.96 2.69s-.25-4.1-3.98-5.1"
      style={{
        fill: "currentColor",
        fillRule: "evenodd",
      }}
      transform="translate(-1074 -1002.03)"
    />
  </svg>
);
export default SvgKulturIconMeny;
